import React from "react";
import styled from "styled-components";
import { theme } from "../theme";
import { useTranslation } from "react-i18next";

const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: clamp(1.25rem, 4vw, 2.5rem) clamp(1rem, 4vw, 2rem);
  color: ${theme.colors.primary};
  min-height: 100vh;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;

  html[lang="ar"] & :is(h1, h2, th, td) {
    text-align: center !important;
  }

`;

const Title = styled.h1`
  font-size: clamp(1.75rem, 5vw, 2.5rem);
  margin-bottom: 1.25rem;
  color: ${theme.colors.primary};
  text-align: center;
`;

const Subtitle = styled.h2`
  font-size: clamp(1.4rem, 4vw, 1.8rem);
  margin-top: 1.875rem;
  color: ${theme.colors.primary};
  text-align: center;
`;

const Table = styled.table`
  width: min(100%, 50rem);
  border-collapse: collapse;
  margin: 1.25rem 0;
  color: ${theme.colors.primary};

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const TableHead = styled.thead`
  background-color: ${theme.colors.primary};
  color: black;
`;

const TableHeader = styled.th`
  padding: clamp(0.75rem, 3vw, 0.9375rem);
  font-size: 1.2em;
  border: 1px solid ${theme.colors.primary};
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: rgba(218, 165, 32, 0.2);
  }
`;

const TableData = styled.td`
  padding: clamp(0.75rem, 3vw, 0.9375rem);
  text-align: center;
  border: 1px solid ${theme.colors.primary};
  font-size: clamp(0.95rem, 3vw, 1.1rem);
`;

const Prices: React.FC = () => {
  const { t, i18n } = useTranslation();
  return (
    <PricesContainer>
      <Title>{t("courses.title")}</Title>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>{t("courses.lessons")}</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData>{t("courses.drivingLesson")}</TableData>
            <TableData>€50,00</TableData>
          </TableRow>
         
          <TableRow>
            <TableData>{t("courses.trialLesson")}</TableData>
            <TableData>€50,00</TableData>
          </TableRow>
      
        
          <TableRow>
            <TableData>{t("courses.intake")}</TableData>
            <TableData>€80,00</TableData> 
          </TableRow>
        </tbody>
      </Table>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>{t("courses.exams")}</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData>{t("courses.practicalExam")}</TableData>
            <TableData>€300,00</TableData>
          </TableRow>
         
          <TableRow>
            <TableData>{i18n.language === "ar" ? "الامتحان التجريبي" : t("courses.interimTest")}</TableData>
            <TableData>€300,00</TableData>
          </TableRow>
          <TableRow>
            <TableData>{t("courses.bnorExam")}</TableData>
            <TableData>€330,00</TableData>
          </TableRow>
          <TableRow>
            <TableData>{i18n.language === "ar" ? "امتحان الستريس" : t("courses.anxietyExam")}</TableData>
            <TableData>€385,00</TableData>
          </TableRow>
        </tbody>
      </Table>

      <Subtitle>{t("courses.packages")}</Subtitle>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>{t("courses.package", { name: "A" })}</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData colSpan={2}>{t("courses.intake")}</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.lessonCount", { count: 15 })}</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.practicalExam")}</TableData>
          </TableRow>
          <TableRow>
            <TableData>{t("courses.price")}</TableData>
            <TableData>€1100,00</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.payment")}</TableData>
          </TableRow>
        </tbody>
      </Table>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>{t("courses.package", { name: "B" })}</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData colSpan={2}>{t("courses.intake")}</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.lessonCount", { count: 20 })}</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.practicalExam")}</TableData>
          </TableRow>
          <TableRow>
            <TableData>{t("courses.price")}</TableData>
            <TableData>€1340,00</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.payment")}</TableData>
          </TableRow>
        </tbody>
      </Table>

      <Table>
        <TableHead>
          <tr>
            <TableHeader colSpan={2}>{t("courses.package", { name: "C" })}</TableHeader>
          </tr>
        </TableHead>
        <tbody>
          <TableRow>
            <TableData colSpan={2}>{t("courses.intake")}</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.lessonCount", { count: 30 })}</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.practicalExam")}</TableData>
          </TableRow>
          <TableRow>
            <TableData>{t("courses.price")}</TableData>
            <TableData>€1820,00</TableData>
          </TableRow>
          <TableRow>
            <TableData colSpan={2}>{t("courses.payment")}</TableData>
          </TableRow>
        </tbody>
      </Table>
    </PricesContainer>
  );
};

export default Prices;
